// extracted by mini-css-extract-plugin
export var alternate = "_p-j";
export var black = "_p-6";
export var blue = "_p-f";
export var blueLight = "_p-e";
export var brand = "_p-8";
export var darkMode = "_p-b";
export var error = "_p-a";
export var gray = "_p-5";
export var grayBlue = "_p-d";
export var iconWrapper = "_p-3";
export var inactive = "_p-7";
export var indigo = "_p-g";
export var orange = "_p-i";
export var pink = "_p-h";
export var primary = "_p-0";
export var purple = "_p-9";
export var success = "_p-4";
export var warning = "_p-c";
export var white = "_p-1";
export var whiteSuccess = "_p-2";